module.exports = __webpack_public_path__ + "static/img/bind.2e4bc12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sharing/bind.png
// module id = hqD0
// module chunks = 59